/**
 * Cliente HTTP para os KPIs do escritório (E18.F1.T02/T06). // ux-neutrality:allow doc-comment
 *
 * GET /api/escritorio/kpis → OfficeKpisData // ux-neutrality:allow doc-comment
 */
import axios, { AxiosError, type AxiosInstance } from 'axios';

export interface OfficeKpisData {
  tempo_medio_analise_horas: number | null;
  lr_autoria_count: number;
  lr_heteroautoria_count: number;
}

export class KpisError extends Error {
  public readonly reason: 'network' | 'unknown';

  constructor(reason: 'network' | 'unknown', message?: string) {
    super(message ?? reason);
    this.reason = reason;
    this.name = 'KpisError';
  }
}

export async function getOfficeKpis(apiClient: AxiosInstance): Promise<OfficeKpisData> {
  try {
    // Caminho relativo: o client já carrega `/api` no baseURL (lib/api.ts).
    // Repetir o prefixo aqui produzia GET /api/api/escritorio/kpis → 404 em
    // todo request, e os indicadores nunca chegaram a carregar.
    const res = await apiClient.get<OfficeKpisData>('/escritorio/kpis');
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const axiosErr = err as AxiosError;
      if (axiosErr.code === 'ERR_NETWORK' || axiosErr.code === 'ECONNABORTED') {
        throw new KpisError('network');
      }
    }
    throw new KpisError('unknown');
  }
}
